import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { UploadStatusProps } from '../../../types/reduxTypes/uploadStatus';

const createReducer = <T extends SliceCaseReducers<UploadStatusProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setUploadStatusData(state, action) {
    state.uploadStatusData = action.payload;
  }
});

export default reducers;
